import React from "react";
import DollarIcon from "../component/DollarIcon";

const packages = [
  {
    name: "copybar",
    homepage: "https://github.com/rumkin/copybar",
    version: "1.0",
    about: "CopyBar specification.",
    author: {
      name: "Paul Rumkin",
      homepage: "https://rumk.in",
    },
  },
  {
    name: "feather",
    homepage: "https://feathericons.com/",
    version: "4.20",
    about: "Beautiful open source vertor icons",
    author: {
      name: "Cole Bemis",
      homepage: "https://github.com/colebemis",
    },
    sponsorship: "https://www.paypal.me/colebemis/5",
  },
];

export default function AboutPage() {
  return (
    <>
      <header className="Page-header">
        <h1>About</h1>
      </header>
      <section className="Page-body">
        <h2>CopyBar Demo</h2>
        <p>
          Version: <strong>v1.0</strong>
        </p>
        <p>CopyBar implementation demostation.</p>
        <h3>Contributors</h3>
        <PackageList packages={packages} />
      </section>
    </>
  );
}
export function PackageList({ packages }) {
  return (
    <ul className="PackageList">
      {packages.map(
        ({ name, homepage, version, about, author, sponsorship }, i) => (
          <li key={name} className="PackageList-item">
            <div className="PackageList-itemBox">
              <header className="PackageList-itemHeader">
                <div className="PackageList-itemHeaderTop">
                  <h3 className="PackageList-pkgName">
                    <a className="PackageList-pkgLink" href={homepage}>
                      {name}
                    </a>{" "}
                  </h3>
                  {sponsorship ? (
                    <div className="PackageList-sponsorship">
                      <a
                        className="btn PackageList-sponsor"
                        title="Sponsor"
                        href={sponsorship}
                      >
                        <DollarIcon size={16} />
                      </a>
                    </div>
                  ) : null}
                </div>
                <div>
                  <span className="PackageList-pkgVer">v{version}</span>{" "}
                  <span>by</span>{" "}
                  {author.homepage ? (
                    <a href={author.homepage}>{author.name}</a>
                  ) : (
                    author.name
                  )}
                </div>
              </header>
              <p className="PackageList-desc">{about}</p>
            </div>
          </li>
        ),
      )}
    </ul>
  );
}
